export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const SET_PARTICIPANT = 'SET_PARTICIPANT';
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const UPDATE_PARTICIPANT = 'UPDATE_PARTICIPANT';
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
export const CLEAR_PARTICIPANT = 'CLEAR_PARTICIPANT';
export const CLEAR_PARTICIPANTS = 'CLEAR_PARTICIPANTS';
